import React from 'react';
import Mediapipe from './pages/Mediapipe';

function App() {
  return <Mediapipe />;
}

export default App;
